<i
  class="f-i f-i-info text-muted align-middle cursor-pointer"
  container="body"
  fMobilePopover
  [mobilePopoverTitle]="localizedTitle()"
  [ngbPopover]="infoPopoverContent"
  [ngClass]="iconSize()"
  [triggers]="'hover focus'"
  [attr.data-automation-id]="'icon-' + title()"
></i>

@if (showTitle()) {
<span>{{ localizedTitle() }}</span>
}

<ng-template #infoPopoverContent>
  @if (mainInfo()) {
  <div>{{ mainInfo() }}</div>
  } @if (infoSecondaryDescription()) {
  <div class="mt-2">{{ infoSecondaryDescription() }}</div>
  } @if (fullTitle()) {
  <p class="fw-bold">{{ fullTitle() }}</p>
  <p class="fw-bold pt-2">{{ titleArticle6() }}:</p>
  <p>{{ infoArticle6() }}</p>
  <p class="fw-bold pt-2">{{ titleArticle8() }}:</p>
  <p>{{ infoArticle8() }}</p>
  <p class="fw-bold pt-2">{{ titleArticle9() }}:</p>
  <p>{{ infoArticle9() }}</p>
  }
</ng-template>
